module.exports = __webpack_public_path__ + "static/media/main-bg-md.4c18d3fa.jpg";